import apiService from '../../../services/api-client';
import { PostGoogleLoginRequest, PostGoogleLoginResponse } from '../interfaces/post-google-login';
import { PostGoogleSyncRequest, PostGoogleSyncResponse } from '../interfaces/post-google-sync';
import { PostLoginRequest, PostLoginResponse } from '../interfaces/post-login';
import {
  PostRefreshRequest,
  PostRefreshResponse,
} from '../interfaces/post-refresh';
import { PostSignUpRequest } from '../interfaces/post-sign-up';

export const authApiService = {
  async postLogin(body: PostLoginRequest) {
    const { data } = await apiService().post<PostLoginResponse>(
      `auth/login`,
      body
    );
    return data;
  },
  async postSignUp(body: PostSignUpRequest) {
    const { data } = await apiService().post<PostLoginResponse>(
      `auth/signup`,
      body
    );
    return data;
  },
  async postGoogleLogin(body: PostGoogleLoginRequest) {
    const { data } = await apiService().post<PostGoogleLoginResponse>(
      `auth/google`,
      body
    );
    return data;
  },
  async postGoogleSync(body: PostGoogleSyncRequest) {
    const { data } = await apiService().post<PostGoogleSyncResponse>(
      `auth/sync`,
      body
    );
    return data;
  },
  async postRefresh(body: PostRefreshRequest) {
    const { data } = await apiService().post<PostRefreshResponse>(
      `auth/refresh`,
      body
    );
    return data;
  },
};
